import { TimeoutError } from '@cian/peperrors';

export function timeoutPromise<T>(promise: Promise<T>, timeout: number, domain?: string): Promise<T> {
  return Promise.race([
    promise,
    new Promise<never>((_, reject) =>
      setTimeout(
        () =>
          reject(
            new TimeoutError({
              message: 'Таймаут при отправке сообщения',
              domain: domain || 'timeout',
            }),
          ),
        timeout,
      ),
    ),
  ]);
}
